module.exports = __webpack_public_path__ + "abranch_3.png?672cceb70af1784cebfb60356262224d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/abranch_3.png
// module id = 80
// module chunks = 0